<div class="scoreView {{ sportTypeEnum === 5 ? 'vertical_item_app': '' }}">
  <ng-container *ngIf="defaultSwitch && sportTypeEnum != 5" >
  <span [ngStyle]="styles.spans" class="{{fixtureItem?.homegoalcss}}">{{fixtureItem.Score.split(':')[0]}}</span>
  <span [ngStyle]="styles.spans">:</span>
  <span [ngStyle]="styles.spans" class="{{fixtureItem?.awaygoalcss}}">{{fixtureItem.Score.split(':')[1]}}</span>
  </ng-container>
  <ng-container *ngIf="sportTypeEnum === 5">
 <div class="vertical_item">
   <span [ngStyle]="styles.spans">{{fixtureItem.GameScore.split(':')[0]}}</span>
   <span [ngStyle]="styles.spans">{{fixtureItem.GameScore.split(':')[1]}}</span>
 </div>
    <div class="vertical_item" *ngIf="fixtureItem.GameScore2 != '' ">
      <span [ngStyle]="styles.spans">{{fixtureItem.GameScore2.split(':')[0]}}</span>
      <span [ngStyle]="styles.spans">{{fixtureItem.GameScore2.split(':')[1]}}</span>
    </div>
    <div class="vertical_item"  *ngIf="fixtureItem.GameScore3 != '' ">
      <span [ngStyle]="styles.spans">{{fixtureItem.GameScore3.split(':')[0]}}</span>
      <span [ngStyle]="styles.spans">{{fixtureItem.GameScore3.split(':')[1]}}</span>
    </div>

  </ng-container>
</div>
